<template>
  <div
    class="gj-table el-table el-table--fit el-table--enable-row-transition"
    style="width: 100%; height: 100%;"
  >
    <div class="el-table__header-wrapper">
      <table cellspacing="0" cellpadding="0" border="0" class="el-table__header card-table-header">
        <colgroup>
          <col :width="item" v-for="(item, index) in colgroup" :key="index">
        </colgroup>
        <thead class="has-gutter">
          <tr class>
            <th colspan="1" rowspan="1" class="el-table_1_column_1">
              <div class="cell">Products</div>
            </th>
            <th colspan="1" rowspan="1" class="el-table_1_column_2">
              <div class="cell">Range</div>
            </th>
            <th colspan="1" rowspan="1" class="el-table_1_column_3">
              <div class="cell">Middle</div>
            </th>
            <th colspan="1" rowspan="1" class="el-table_1_column_4">
              <div class="cell">Change</div>
            </th>
            <th colspan="1" rowspan="1" class="el-table_1_column_5">
              <div class="cell">Unit</div>
            </th>
            <th colspan="1" rowspan="1" class="el-table_1_column_6">
              <div class="cell">Date</div>
            </th>
          </tr>
        </thead>
      </table>
    </div>
    <div class="el-table__body-wrapper table-fixed-body">
      <el-scrollbar>
        <table
          cellspacing="0"
          cellpadding="0"
          border="0"
          class="el-table__body"
          style="width: 100%;"
        >
          <colgroup>
            <col :width="item" v-for="(item, index) in colgroup" :key="index">
          </colgroup>
          <tbody>
            <tr
              class="el-table__row"
              v-for="(item, index) in data"
              :key="index"
              @click.stop="rowClick(data[index], index)"
            >
              <td rowspan="1" colspan="1" class="el-table_1_column_1 name-color">
                <div class="cell" :class="{'cell-icon': item.showIcon === 'Y'}">
                  <!-- <div class="premiums-contract" v-if="item.type==='premiums'">{{item.refTo}}</div> -->
                  <el-tooltip
                    effect="light"
                    :content="computedName(item)"
                    popper-class="cell-detail"
                    :hide-after="0"
                    placement="top-start"
                  >
                    <span class="contract-container">
                      <slot>
                        <i class="row-icon"></i>
                      </slot>
                      <span class="contract-name">                      
                        <span class="cell-name">{{item.name}}<span>{{item.refTo?(item.refTo):''}}</span></span>
                        <i class="new-icon" v-if="item.showIcon === 'Y'"></i>
                      </span>
                    </span>
                  </el-tooltip>
                </div>
              </td>
              <td rowspan="1" colspan="1" class="el-table_1_column_2">
                <div
                  class="cell"
                  v-if="item.type === 'premiums'"
                >{{upDownIdentify(item.low) + '' + absValue(item.low)}} - {{upDownIdentify(item.high) + '' + absValue(item.high)}}</div>
                <div class="cell" v-else>{{$handleValue(item.low)}} - {{$handleValue(item.high)}}</div>
              </td>
              <td rowspan="1" colspan="1" class="el-table_1_column_3">
                <div
                  class="cell"
                  v-if="item.type === 'premiums'"
                >{{upDownIdentify(item.middle) + '' + absValue(item.middle)}}</div>
                <div class="cell" v-else>{{$handleValue(item.middle)}}</div>
              </td>
              <td rowspan="1" colspan="1" class="el-table_1_column_4 updown-color">
                <div class="cell">
                  <span
                    class="color-relative"
                    :class="upDownClass(item.change)"
                  >{{$handleValue(item.change, true)}}</span>
                </div>
              </td>
              <td rowspan="1" colspan="1" class="el-table_1_column_5 unit-color">
                <div class="cell">{{item.unit?item.unit:'-'}}</div>
              </td>
              <td rowspan="1" colspan="1" class="el-table_1_column_6 unit-color">
                <!-- <div class="cell">{{computedTime(item.time)}}</div> -->
                <div class="cell">{{item.time}}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
// import { upDownClass, formatDate } from '@/utils/util'
import { upDownClass } from '@/utils/util'
export default {
  name: 'GjTable',
  componentName: 'GjTable',
  props: {
    data: {
      type: Array
    }
  },
  data() {
    return {
      // colgroup: [205, 115, 70, 60, 60, 60]
      colgroup: [100, 70, 55, 55, 50, 45]
    }
  },
  methods: {
    rowClick(item, index) {
      this.$emit('row-click', item, index)
    },
    upDownClass(value) {
      return upDownClass(value)
    },
    upDownIdentify(value) {
      let identify = '';
      if (value && Number(value) > 0) {
        // 升是B
        identify = 'b'
      } else if (value && Number(value) < 0) {
        // 贴是C
        identify = 'c'
      }
      return identify
    },
    computedName(item) {
      var itemName
      if (item.type === 'premiums') {
        itemName = `${item.name} (${item.refTo})`
      } else {
        itemName = item.name
      }
      // return (<i class="el-icon-s-marketing row-icon"></i> <span> itemName</span> )
      return itemName
    },
    absValue(value) {
      return this.$handleValue(Math.abs(value))
    }/* ,
    computedTime(time) {
      var newTime
      // 当天
      if (new Date(time).toDateString() === new Date().toDateString()) {
        newTime = formatDate(time, 'HH:ss')
      } else {
        newTime = formatDate(time, 'dd/MM/yyyy hh:mm')
      }
      return newTime
    } */
  }
};

</script>



// WEBPACK FOOTER //
// src/components/table/src/main.vue